export type LoadingScreenProps = {
  /** Progress 0–1 from asset preload. */
  progress?: number;
};

export type LoadingScreenModel = {
  progress: number;
};

export function createLoadingScreenModel(
  props: LoadingScreenProps,
): LoadingScreenModel {
  return {
    progress: Math.max(0, Math.min(1, props.progress ?? 0)),
  };
}
